// export interface profileData
import mario64Art from "./img/games/mario64.jpg";
import baldursgateArt from "./img/games/baldursgate.jpg";
import megaman4Art from "./img/games/megaman4.jpg";
import turtlesArt from "./img/games/turtles.jpg";
import zelda3Art from "./img/games/zelda3.jpg";
import twitterLogo from "./img/twitter.png";
import twitchLogo from "./img/twitch.png";
import ytLogo from "./img/yt.png";
import avatar from "./img/avatar.png";

import arcus87Avatar from "./img/avatars/arcus87.png";
import catsonurheadAvatar from "./img/avatars/catsonurhead.png";
import noclipAvatar from "./img/avatars/noclip.jpg";
import gamechasersAvatar from "./img/avatars/gamechasers.jpg";
import codblops4Art from "./img/games/codblops4.jpg";
import dota2Art from "./img/games/dota2.jpg";
import rdr2Art from "./img/games/rdr2.jpg";
import thewitnessArt from "./img/games/thewitness.jpg";
import mario3Art from "./img/games/mario3.jpg";
import wowClassicArt from "./img/games/wowClassic.jpg";
import hearthstoneArt from "./img/games/hearthstone.jpg";

export const profile = {
  age: "30",
  name: "Tjäder",
  location: "Sweden",
  avatar,
  description: `Been gaming for as long as I can remember. My earliest memories consists Of playing DOS—games like Digger and Scorched Earth together with my parents. When I got a NES on my 5th birthday gaming cemented itself as a big passion and part Of my life and since then been gaming pretty much every day in some way.`,
  links: [
    { imageUrl: twitterLogo, alias: "AirJohan", imageAltText: "Twitter" },
    { imageUrl: twitchLogo, alias: "AirJohan", imageAltText: "Twitch" },
    { imageUrl: ytLogo, alias: "AirJohan", imageAltText: "YouTube" }
  ],
  watching: [
    { broadcasterId: "arcus87", note: "Down to earth cowboy and speedrunner." },
    {
      broadcasterId: "noclip",
      note: "High quality documentaries about games and the people behind them."
    },
    {
      broadcasterId: "kertz",
      note: "Speedrunner with cats on her head"
    },
    {
      broadcasterId: "gamechasers",
      note: "Retro gaming and nostalgia in general"
    }
  ],
  broadcasters: {
    arcus87: {
      name: "Arcus87",
      imageUrl: arcus87Avatar,
      linkUrl: "https://www.twitch.tv/arcus87",
      platformId: "twitch"
    },
    kertz: {
      name: "Catsonurhead",
      imageUrl: catsonurheadAvatar,
      linkUrl: "https://www.twitch.tv/catsonurhead",
      platformId: "twitch"
    },
    noclip: {
      name: "noclip",
      imageUrl: noclipAvatar,
      linkUrl: "https://www.youtube.com/channel/UC0fDG3byEcMtbOqPMymDNbw",
      platformId: "youtube"
    },
    gamechasers: {
      name: "Game Chasers",
      imageUrl: gamechasersAvatar,
      linkUrl: "https://jytjob.comm",
      platformId: "youtube"
    }
  },
  broadcastPlatforms: {
    twitch: { name: "twitch.tv", imageUrl: twitchLogo },
    youtube: { name: "YouTube", imageUrl: ytLogo }
  },
  favoriteGames: {
    1: {
      key: 1,
      gameId: "mario",
      description:
        "The defining game of my childhood. The leap to 3D graphics is something I will never get to experience again."
    },
    2: { key: 2, gameId: "zelda", description: "Nice zelda game" },
    3: {
      key: 3,
      gameId: "turtles",
      description:
        "A lot of people dislike this game. While I can see why I still think it’s a good game. It’s far from a perfect game. But it really is one of my favorites. You can’t deny that it has great graphics, great music and fun gameplay. It’s a great game, it really is! But the difficulty, wow. This game is so hard. As I said in my video where I was talking about my top NES games, I have had this game most of my life and I’ve still not beaten it. There’s no excuses. I have to do something about that."
    },
    4: { key: 4, gameId: "baldurs", description: "Nice baldurs game" },
    5: { key: 5, gameId: "megaman", description: "Nice megaman game." }
  },
  playing: [
    { gameId: "codblops4", platform: "PC" },
    { gameId: "dota2", platform: "PC" },
    { gameId: "rdr2", platform: "PS4" },
    { gameId: "thewitness", platform: "PC" }
  ],
  accomplishments: [
    {
      id: "79265837-3343-43a5-a347-0f4694024efe",
      date: "2016-11-09",
      type: "speedrun",
      gameId: "mario3",
      speedrun: {
        time: "1:10:19",
        category: "100%"
      }
    },
    {
      id: "3d7e5f3e-dc52-4888-809a-af53dad4304f",
      date: "2006-12-16",
      type: "achievement",
      gameId: "wowClassic",
      achievement: {
        title: "Killed Four Horsemen"
      }
    },
    {
      id: "dcc8369d-b221-43a2-b135-2b7531871457",
      date: "2017-03-14",
      gameId: "hearthstone",
      type: "rank",
      rank: {
        title: "Legenday"
      }
    }
  ],
  games: {
    mario: {
      title: "Super Mario 64",
      year: "1996",
      platform: "N64",
      artUrl: mario64Art
    },
    zelda: {
      title: "Zelda: A Link to the past",
      year: "1991",
      platform: "SNES",
      artUrl: zelda3Art
    },
    turtles: {
      title: "TMNT: Turtles in Time",
      year: "1991",
      platform: "SNES",
      artUrl: turtlesArt
    },
    baldurs: {
      title: "Baldurs Gate II: Shadows of Amn",
      year: "2000",
      platform: "PC/MAC",
      artUrl: baldursgateArt
    },
    megaman: {
      title: "Mega Man 4",
      year: "1991",
      platform: "NES",
      artUrl: megaman4Art
    },
    codblops4: {
      title: "Call of Duty: Black Ops 4",
      year: "",
      platform: "PC",
      artUrl: codblops4Art
    },
    dota2: {
      title: "Dota 2",
      year: "",
      platform: "PC",
      artUrl: dota2Art
    },
    rdr2: {
      title: "Red Dead Redemption 2",
      year: "",
      platform: "Xbox One / PS4",
      artUrl: rdr2Art
    },
    thewitness: {
      title: "The Witness",
      year: "",
      platform: "PC",
      artUrl: thewitnessArt
    },
    mario3: {
      title: "Super Mario Bros. 3",
      year: "",
      platform: "NES",
      artUrl: mario3Art
    },
    wowClassic: {
      title: "World of Warcraft Classic",
      year: "",
      platform: "PC",
      artUrl: wowClassicArt
    },
    hearthstone: {
      title: "Hearthstone",
      year: "",
      platform: "PC",
      artUrl: hearthstoneArt
    }
  }
};



// WEBPACK FOOTER //
// ./src/profileData.ts